import React, { useEffect } from 'react';

// Ventana grande sobre la pantalla; se cierra con Escape, con la X o tocando afuera.
export default function Ventana({ titulo, alCerrar, children, ancho = 'max-w-7xl' }) {
  useEffect(() => {
    const teclado = (e) => { if (e.key === 'Escape') alCerrar(); };
    window.addEventListener('keydown', teclado);
    return () => window.removeEventListener('keydown', teclado);
  }, [alCerrar]);
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-slate-900/50 p-2 sm:p-6" role="dialog" aria-modal="true" aria-label={titulo}
      onMouseDown={(e) => { if (e.target === e.currentTarget) alCerrar(); }}>
      <div className={`w-full ${ancho} rounded-2xl bg-slate-50 p-2 shadow-2xl dark:bg-slate-900 sm:p-4`}>
        {/* La X va en su propia fila para no tapar los botones del contenido. */}
        <div className="mb-2 flex items-center justify-between gap-2 px-1">
          <h2 className="truncate text-base font-extrabold text-slate-800 dark:text-slate-100">{titulo}</h2>
          <button type="button" onClick={alCerrar} aria-label="Cerrar"
            className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white text-slate-700 shadow hover:bg-slate-100 dark:bg-slate-700 dark:text-slate-100">
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
